/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type FinancialProductExpenseItemFinancialProductType =
  (typeof FinancialProductExpenseItemFinancialProductType)[keyof typeof FinancialProductExpenseItemFinancialProductType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FinancialProductExpenseItemFinancialProductType = {
  building_saving: "building_saving",
  pension_saving: "pension_saving",
  saving_account: "saving_account",
  investment: "investment",
  real_estate_fund: "real_estate_fund",
  commodities: "commodities",
  platform: "platform",
  other: "other",
} as const;
